/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/

import * as fromSports from 'app/shared/store/actions/sports.action';

export interface SportsState {
  sports: any[];
  errorMessage: string;
  success: boolean;
  failed: boolean;
  loading: boolean;
}

export const initialState = {
  sports: [],
  errorMessage: '',
  success: false,
  failed: false,
  loading: false,
};

export function reducer(state = initialState, action: fromSports.SportsAction): SportsState {
  switch (action.type) {
    case fromSports.GET_SPORTS: {
      return {
        ...state,
        sports: [],
        loading: true,
        success: false,
        failed: false,
      };
    }

    case fromSports.GET_SPORTS_SUCCESS: {
      return {
        ...state,
        sports: action.payload,
        loading: false,
        success: true,
      };
    }

    case fromSports.GET_SPORTS_FAIL: {
      return {
        ...state,
        errorMessage: action.payload,
        loading: false,
        failed: true,
      };
    }
  }
  return state;
}

export const getSports = (state: SportsState) => state.sports;
export const getSportsLoading = (state: SportsState) => state.loading;
export const getSportsSuccess = (state: SportsState) => state.success;
export const getSportsFail = (state: SportsState) => ({ failed: state.failed, message: state.errorMessage });
